export class IVSBroadcaster {
  private client: any = null;
  private streamId: string;
  private userId: string;
  private ingestEndpoint: string | null = null;
  private streamKey: string | null = null;

  constructor(streamId: string, userId: string) {
    this.streamId = streamId;
    this.userId = userId;
  }

  async initialize(stream: MediaStream) {
    try {
      console.log('Fetching AWS IVS configuration...');
      const { supabase } = await import('@/integrations/supabase/client');
      
      // Get IVS channel configuration from backend
      const { data: configData, error: configError } = await supabase.functions.invoke('get-ivs-config', {
        body: {
          streamId: this.streamId,
          userId: this.userId,
        }
      });

      if (configError || !configData?.ingestEndpoint || !configData?.streamKey) {
        console.error('IVS config fetch error:', configError);
        throw new Error(`Failed to get IVS configuration: ${configError?.message || 'No configuration received'}`);
      }

      this.ingestEndpoint = configData.ingestEndpoint;
      this.streamKey = configData.streamKey;

      console.log('IVS configuration received successfully');
      console.log('Initializing AWS IVS broadcaster...');

      // Import and create broadcast client
      const IVSModule: any = await import('amazon-ivs-web-broadcast');
      const IVSBroadcastClient = IVSModule.IVSBroadcastClient || IVSModule.AmazonIVSBroadcastClient || IVSModule.default;

      this.client = IVSBroadcastClient.create({
        streamConfig: IVSBroadcastClient.STANDARD_LANDSCAPE,
      });

      // Add media streams
      const videoTrack = stream.getVideoTracks()[0];
      const audioTrack = stream.getAudioTracks()[0];

      if (videoTrack) {
        const videoStream = new MediaStream([videoTrack]);
        await this.client.addVideoInputDevice(videoStream, 'camera', { index: 0 });
      }

      if (audioTrack) {
        const audioStream = new MediaStream([audioTrack]);
        await this.client.addAudioInputDevice(audioStream, 'microphone');
      }

      await this.client.startBroadcast(this.streamKey!, this.ingestEndpoint!);
      console.log('AWS IVS broadcasting started successfully');
    } catch (error) {
      console.error('Failed to initialize IVS broadcaster:', error);
      throw error;
    }
  }

  async stopBroadcast() {
    try {
      if (this.client) {
        await this.client.stopBroadcast();
        this.client = null;
      }
      console.log('IVS broadcast stopped successfully');
    } catch (error) {
      console.error('Error stopping IVS broadcast:', error);
    }
  }

  getClient(): any {
    return this.client;
  }
}
